<template>
    <CardPage :section="18" :page="4" :nextDisabled="nextDisabled">
        <p>
            What do you think Billi could do in this situation to maintain her boundary? Select from the options below:
        </p>
        <div
            v-for="(key, index) in responsesOrder"
            :key="index"
            class="grey pa-3 mb-1 response"
            :class="{ 'lighten-3': !responses[key].selected }"
            @click.stop="select(responses[key])"
            v-ripple
        >
            {{ responses[key].text }}
            <div class="check" v-if="responses[key].selected">
                <v-avatar class="success">
                    <v-icon small dark>check</v-icon>
                </v-avatar>
            </div>
        </div>
        <div class="empty-height font-italic text-xs-center">
            <span v-if="pickOneMore">(pick one more)</span>
        </div>
        <ModalFeedback ref="modalFeedback"></ModalFeedback>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    data() {
        return {
            pickOneMore: false
        };
    },
    computed: {
        responses: get('section18/responses'),
        responsesOrder: get('section18/responsesOrder'),
        hasUnselectedCorrectResponses: get('section18/hasUnselectedCorrectResponses')
    },
    methods: {
        select(response) {
            this.$refs.modalFeedback.show(response.correct, response.feedback, () => {
                if (response.correct) {
                    this.$store.set(`section18/responses@${response.id}.selected`, true);
                    this.pickOneMore = this.hasUnselectedCorrectResponses;
                }
            });
        },
        nextDisabled() {
            return this.hasUnselectedCorrectResponses;
        }
    }
};
</script>

<style scoped>
.response {
    position: relative;
}
.check {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>
